import { Accordion, Code, Flex, List, Text } from "@mantine/core";

export const messageTemplateInstruction = (
  <Accordion chevronPosition="left">
    <Accordion.Item value="customer">
      <Accordion.Control>Instruction</Accordion.Control>
      <Accordion.Panel>
        <Flex gap={16} direction="column">
          <Flex gap={10} direction="column">
            <Text weight={500}>What is a Template?</Text>
            <Text>
              Templates allow you to dynamically generate messages by using
              placeholders that are replaced with real data.
            </Text>
          </Flex>
          <Flex gap={10} direction="column">
            <Text weight={500}>Available Placeholders</Text>
            <List>
              <List.Item>
                <Code>{"{{InvoiceNumber}}"}</Code> - Replaced with the invoice
                number
              </List.Item>
              <List.Item>
                <Code>{"{{TotalAmountDue}}"}</Code> - Replaced with the total
                amount due for the invoice
              </List.Item>
              <List.Item>
                <Code>{"{{TotalAccountReceivable}}"}</Code> - Replaced with the
                total account receivable for the invoice
              </List.Item>
              <List.Item>
                <Code>{"{{InvoiceDueDate}}"}</Code> - Replaced with the due date
                of the invoice
              </List.Item>
              <List.Item>
                <Code>{"{{CustomerName}}"}</Code> - Replaced with the
                customer&apos;s name
              </List.Item>
              <List.Item>
                <Code>{"{{PICName}}"}</Code> - Replaced with the name of the
                person in charge
              </List.Item>
              <List.Item>
                <Code>{"{{DueDateFromToday}}"}</Code> - Replaced with the number
                of days until the invoice is due
              </List.Item>
              <List.Item>
                <Text>
                  To include multiple items (e.g., invoices), use the{" "}
                  <Code>{"{{#each}}"}</Code> helper. For ex.:
                </Text>
                <Code>
                  {
                    "{{#each Invoices}} - Invoice Number: {{InvoiceNumber}}, Amount: {{TotalAmountDue}} {{/each}}"
                  }
                </Code>
                <Text>
                  This will populate a list of invoices with their numbers and
                  amounts for each item in your data.
                </Text>
              </List.Item>
            </List>
          </Flex>
          <Flex gap={10} direction="column">
            <Text weight={500}>Example</Text>
            <Flex direction="column">
              <Text>
                Template:{" "}
                <Code block>
                  {`Hello {{CustomerName}}!
You have unpaid invoices:
{{#each Invoices}}
- Invoice Number: {{InvoiceNumber}}, Amount: {{Amount}} 
{{/each}}`}
                </Code>
              </Text>
              <Text>
                Output:{" "}
                <Code block>
                  {`Hello John Doe!
You have unpaid invoices:
- Invoice Number: INV-M1-MITM-40-03-25-0305, Amount: Rp.59,999,998.28
- Invoice Number: INV-M1-MITM-40-03-25-0306, Amount: Rp.126,416,865.79
`}
                </Code>
              </Text>
            </Flex>
          </Flex>
        </Flex>
      </Accordion.Panel>
    </Accordion.Item>
  </Accordion>
);
